import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API } from "../lib/api";
import { Folder } from "lucide-react";
import { useContent, imgSrc } from "../lib/content";

function FolderCard({ f }) {
  return (
    <Link to={`/gallery/${f.id}`} className="card-dark group block" data-testid={`folder-card-${f.id}`}>
      <div className="aspect-[4/3] bg-neutral-950 overflow-hidden flex items-center justify-center">
        {f.cover_id
          ? <img src={`${API}/media/file/${f.cover_id}`} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-700"/>
          : <Folder className="w-12 h-12 text-neutral-700"/>}
      </div>
      <div className="p-4 flex items-center justify-between">
        <div className="font-display text-lg">{f.name}</div>
        <div className="font-mono text-[10px] tracking-widest text-neon">{f.count} FILE</div>
      </div>
    </Link>
  );
}

export default function Gallery() {
  const { c } = useContent();
  const [items, setItems] = useState([]);
  const [folders, setFolders] = useState([]);
  useEffect(() => {
    api.get("/gallery").then(r=>setItems(r.data));
    api.get("/media/folders").then(r=>setFolders(r.data));
  }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16">
      <div className="label-mono text-neon mb-2">{c.gallery_label}</div>
      <h1 className="font-display text-4xl lg:text-6xl mb-4">{c.gallery_title}</h1>
      <p className="text-neutral-400 mb-10 max-w-xl">{c.gallery_subtitle}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
        {folders.length === 0 && <div className="label-mono text-neutral-500">// NESSUNA CARTELLA ANCORA</div>}
        {folders.map(f => <FolderCard key={f.id} f={f}/>)}
      </div>

      <div className="label-mono text-alert mb-2">{c.gallery_archive_label}</div>
      <h2 className="font-display text-3xl lg:text-4xl mb-8">{c.gallery_archive_title}</h2>
      <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-3 space-y-3">
        {items.map((it, i) => (
          <div key={it.id} className="break-inside-avoid relative overflow-hidden border border-neutral-900 group" data-testid={`gallery-${i}`}>
            <img src={imgSrc(it.url)} alt="" loading="lazy" className="w-full group-hover:scale-105 transition duration-700"/>
          </div>
        ))}
      </div>
    </div>
  );
}
